import { CommonModule } from '@angular/common';
import { Component, forwardRef, NgModule, Input, ViewChild, ElementRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputSwitch } from 'primeng/inputswitch';

export const INPUTSWITCH_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => CVCInputSwitch),
  multi: true,
};

@Component({
  selector: 'cvc-inputSwitch',
  templateUrl: './input-switch.html',
  providers: [INPUTSWITCH_VALUE_ACCESSOR],
  standalone: false,
})
export class CVCInputSwitch extends InputSwitch {
  @Input() onLabel: string;
  @Input() offLabel: string;
  @Input() label: string;
  @Input() labelClass: string;

  // PrimeNG 16 queries "#input" (used by onClick for focus); this template names the native input "#cb".
  @ViewChild('cb') input: ElementRef;

  // PrimeNG 16 dropped onClick(event, cb) and onInputChange(event); these keep the PrimeNG 15.3 behavior.
  onSwitchClick(event: Event, cb: HTMLInputElement) {
    if (!this.disabled && !this.readonly) {
      this.onClick(event);
      cb.focus();
    }
  }

  onInputChange(event: Event) {
    if (!this.readonly) {
      const inputChecked = (<HTMLInputElement>event.target).checked;
      this.modelValue = inputChecked ? this.trueValue : this.falseValue;
      this.onModelChange(this.modelValue);
      this.onChange.emit({
        originalEvent: event,
        checked: this.modelValue,
      });
    }
  }
}

@NgModule({
  imports: [CommonModule],
  exports: [CVCInputSwitch],
  declarations: [CVCInputSwitch],
})
export class CVCInputSwitchModule {}
